import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/teacher",
    component: MainLayout,
    name: "teacher",
    redirect: "/teacher/pageList",
    meta: {
      title: "教师管理",
      icon: "file-protect",
    },
    // hidden: true,
    hideChildrenInMenu: true,
    children: [
      {
        path: "/teacher/pageList",
        name: "teacherList",
        component: () => import("@/views/Teacher"),
        meta: {
          title: "教师管理",
        },
      },
    ],
  },
];
